import * as React from 'react';

import {MetricType} from 'common/types/reports/bookmark';
import {SvgIconType} from 'common/components/svg-icon';
import {MetricEntry} from 'common/query-builder/query-entry-section/types';
import {EntryRowProps} from 'iron/common/query-builder/query-entry-section/row-types/types';

import {FunnelBehaviorDefinition} from './funnel/behavior-definition';
import {FunnelMetricMeasurement} from './funnel/measurement';
import {SimpleBehaviorDefinition} from './simple/behavior-definition';
import {SimpleMetricMeasurement} from './simple/measurement';
import {RetentionBehaviorDefinition} from './retention/behavior-definition';
import {RetentionMetricMeasurement} from './retention/measurement';
import {UserBehaviorDefinition} from './user/behavior-definition';
import {UserMetricMeasurement} from './user/measurement';

export const MetricTypeIcons: {[key in MetricType]?: SvgIconType} = {
  [MetricType.Simple]: `behavior-simple`,
  [MetricType.Funnel]: `behavior-funnel`,
  [MetricType.Retention]: `behavior-retention`,
  [MetricType.People]: `users`,
  [MetricType.Cohort]: `users`,
};

type MetricPartsType = {
  [key in MetricType]?: {
    measurement: (props: EntryRowProps<MetricEntry>) => React.ReactNode;
    definition: (props: EntryRowProps<MetricEntry>) => React.ReactNode;
  };
};

/**
 * For each metric, there's a behavior and measurement definition
 * - Measurement defines how a given behavior count is calculated, example: "uniques on Purchase", "totals on Funnel A -> B"
 * - Definition contains the actual event selections & other settings representing a funnel, retention or other types of behaviors
 */
export const MetricParts: MetricPartsType = {
  [MetricType.Simple]: {
    definition: SimpleBehaviorDefinition,
    measurement: SimpleMetricMeasurement,
  },

  [MetricType.Funnel]: {
    definition: FunnelBehaviorDefinition,
    measurement: FunnelMetricMeasurement,
  },

  [MetricType.Retention]: {
    definition: RetentionBehaviorDefinition,
    measurement: RetentionMetricMeasurement,
  },

  [MetricType.People]: {
    definition: UserBehaviorDefinition,
    measurement: UserMetricMeasurement,
  },

  /** @todo(pablo) we will migrate all cohort metrics to be people based metrics */
  [MetricType.Cohort]: {
    definition: UserBehaviorDefinition,
    measurement: UserMetricMeasurement,
  },
};
